module.exports = __webpack_public_path__ + "static/media/flexiteek.9385a00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deck/flexiteek.jpg
// module id = 110
// module chunks = 0